import { useLazyQuery } from '@apollo/client'

import { GetCatAndSubCatSubCategoriesDocument } from '@/graphql/purchase-plus/generated/getCatAndSubCatSubCategories.generated'
import {
  CategoriesQuerySortPropertyEnum,
  SortDirectionEnum,
} from '@/graphql/purchase-plus/generated/purchasePlus_graphql'
import { PURCHASE_PLUS_GRAPHQL_API } from '@/modules/shared/constants'
import { checkNetworkStatus } from '@/modules/shared/utils/checkNetworkStatus'
import { extractEdgesWithType } from '@/modules/shared/utils/extractEdgesWithType'
import { ignoreSingleCharacter } from '@/modules/shared/utils/ignoreSingleCharacter'
import { createPaginationUtils } from '@/modules/shared/utils/paginationUtils'

interface UseGetCatAndSubCatSubCategoriesProps {
  parentId: number
  searchText?: string
}

export function useGetCatAndSubCatSubCategories({ parentId, searchText }: UseGetCatAndSubCatSubCategoriesProps) {
  const paginationResultsPerPage = 10

  const [fetchSubCategories, { data, refetch, fetchMore, networkStatus }] = useLazyQuery(
    GetCatAndSubCatSubCategoriesDocument,
    {
      variables: {
        first: paginationResultsPerPage,
        filters: {
          parentId,
          searchText: ignoreSingleCharacter(searchText) ?? undefined,
        },
        sorts: { property: CategoriesQuerySortPropertyEnum.Name, direction: SortDirectionEnum.Asc },
      },
      context: { uri: PURCHASE_PLUS_GRAPHQL_API },
      fetchPolicy: 'network-only',
      notifyOnNetworkStatusChange: true,
    }
  )

  const pageInfo = data?.categories?.pageInfo

  return {
    fetchSubCategories,
    subCategories: extractEdgesWithType(data?.categories),
    networkStatus,
    loadingStates: checkNetworkStatus(networkStatus),
    refetch,
    ...createPaginationUtils({ pageInfo, fetchMore, refetch, paginationResultsPerPage }),
    pageInfo,
  }
}
